/* eslint-disable */
// import jwtInterceptor from "../Shared/jwtInterceptor";


/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import axios from 'axios';
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import meddraPopup from "../meddraPopup/meddraPopup.vue"
import showformmodel from "../showformmodel/showformmodel.vue"
const idtoken = store.getters.getIdToken;
export default {
    name: 'meddraViewer',
    components: {
        VPagination,
        meddraPopup,
        showformmodel
    },

    props: {
        formId: String,
        tempId: String,
        formStatus: String
    },

    data() {
        return {
            spinner: false,
            meddraVersion: null,
            defaultdate: "",
            baseapi: process.env.VUE_APP_Service_URL,
            baseUrl: `${process.env.VUE_APP_Service_URL}/forms/forms/`,
            selectedVerification: 'all', 
            selectedTerm: null,   
            searchTerm: '',
            showFull: {},
            sites: "",
            setshowFormModal:false,
            meddraenabledfields: [],
            meddra: "",
            idToken: "",
            selectedType: "",
            selectedId: "",
            statusCheck: "",
            searchItem: "",
            currentPageSize: 0,
            currentPageNumber: 1,
            showLoading: true,
            enableNext: true,
            enablePrevious: true,
            showFilter: false,
            dropdownOpen: false,
            selectedcolumnobj: {},
            totalLists: 0,
            totalPages: 0,
            lists: [],
            filteredListing: [],
            dataList: [],
            roleprivileges: "",
            showMeddraModal: false,
            meddrafields: {},
            selectedCategory: 'all'
        }
    },
    async mounted() {
        this.defaultdate = localStorage.getItem("dateformat");

        window.addEventListener("studyIdChanged", async (event) => {
            console.log("StudyIDChanged into" + event.detail.storage);
            this.showLoading = true;
            this.idToken = store.getters.getIdToken;
            this.roleprivileges = store.getters.getRolesprivilegeData;
            await this.getlist();
            this.$nextTick(() => {
                this.initializeMeddraInteractions();
            });
        });

        this.idToken = store.getters.getIdToken;
        this.roleprivileges = store.getters.getRolesprivilegeData;
        await this.getlist();
        this.$nextTick(() => {
            this.initializeMeddraInteractions();
        });
    },
 closeformModal() {
    this.setshowFormModal = false;
},
    methods: {
        initializeMeddraInteractions() {
            const detailButtons = document.querySelectorAll('.view-details');
            const detailPlaceholder = document.getElementById('detailPlaceholder');
            const termDetails = document.getElementById('termDetails');
            const detailName = document.getElementById('detailName');
            const detailCode = document.getElementById('detailCode');
            const detailCategory = document.getElementById('detailCategory');
            const detailDescription = document.getElementById('detailDescription');

            if (detailButtons.length) {
                detailButtons.forEach(button => {
                    button.addEventListener('click', function () {
                        const name = this.getAttribute('data-name');
                        const code = this.getAttribute('data-code');
                        const category = this.getAttribute('data-category');
                        const description = this.getAttribute('data-description');

                        if (detailName) detailName.textContent = name;
                        if (detailCode) detailCode.textContent = code;
                        if (detailCategory) detailCategory.textContent = category;
                        if (detailDescription) detailDescription.textContent = description;

                        if (detailPlaceholder) detailPlaceholder.style.display = 'none';
                        if (termDetails) {
                            termDetails.style.display = 'block';
                            termDetails.scrollIntoView({ behavior: 'smooth' });
                        }
                    });
                });
            }

            const searchInput = document.getElementById('searchInput');
            if (searchInput) {
                searchInput.addEventListener('input', function () {
                    const searchTerm = this.value.toLowerCase();
                    const termCards = document.querySelectorAll('.term-card');
                    termCards.forEach(card => {
                        const termName = card.querySelector('.card-title').textContent.toLowerCase();
                        const termCode = card.querySelector('.code-badge').textContent.toLowerCase();
                        card.parentElement.style.display = (termName.includes(searchTerm) || termCode.includes(searchTerm)) ? 'block' : 'none';
                    });
                });
            }
        },
        
        showDetails(field, level) {
            this.selectedTerm = {
            field: field,
            name: field[level + 'Name'],
            code: field[level + 'Code'],
            level: level.toUpperCase()
            };
            console.log("Showing details for", this.selectedTerm);
            // Scroll to details section
            this.$nextTick(() => {
            const detailsSection = document.getElementById('termDetails');
            if (detailsSection) {
                detailsSection.scrollIntoView({ behavior: 'smooth' });
            }
            });
        },
        showFormpopup(){
            console.log("enter",this.setshowFormModal);
            this.setshowFormModal = true;
        },
        async getlist() {
            const idtoken = store.getters.getIdToken;
            const currentstudy = store.getters.getStudyIs;
            try {
                const res = await axios.get(
                    `${this.baseapi}/medicalcoding-python/meddra/getmeddradata?studyid=${currentstudy}&templateid=${this.tempId}&formid=${this.formId}`,
                    // `http://127.0.0.1:8000/v1/medicalcoding-python/meddra/getmeddradata?studyid=${currentstudy}&templateid=${this.tempId}&formid=${this.formId}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json"
                        }
                    }
                );
                this.meddraenabledfields = [...res.data.MeddraEnabledFields]; 
                this.meddraVersion = this.meddraenabledfields[0]?.MedDRAVersion || null;
                console.log("meddraenabledfields", this.meddraenabledfields);
            } catch (err) {
                console.error(err);
            }
        },
        async verifyMeddra(meddra) {
            const idtoken = store.getters.getIdToken;
            const currentstudy = store.getters.getStudyIs;
            if(confirm(this.$t('navigations.are you sure you want to verify this meddra term?')))
            await axios
                .post(
                    `${this.baseapi}/medicalcoding-python/meddra/meddraverifyterms`,
                    // `http://127.0.0.1:8000/v1/medicalcoding-python/meddra/meddraverifyterms`,
                    {
                        studyid: currentstudy,
                        templateid: this.tempId,
                        formitemid: this.formId,
                        fielddata: {
                            fieldname: meddra.FieldName,
                            verifiedlltname: meddra.LltName
                        }
                    },
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then(async (res) => {
                    console.log(" verifymeddra", res);
                    alert("Meddra term verified successfully");
                    await this.getlist();
                    
                    const updatedField = this.filteredFields.find(f => f.FieldName === meddra.FieldName);
                        if (updatedField) {
                            this.selectedTerm = {
                                field: updatedField,
                                name: updatedField.LltName, // Default to LLT level
                                code: updatedField.LltCode,
                                level: 'LLT'
                            };
                        
                            this.$nextTick(() => {
                                const detailsSection = document.getElementById('termDetails');
                                if (detailsSection) {
                                    detailsSection.scrollIntoView({ behavior: 'smooth' });
                                }
                            });
                        }


                })
                .catch((err) => {
                    console.log(err);
                });
        },
        async openMeddra(meddra) {
            this.selectedTerm = null;
            this.meddrafields = meddra;
            this.showMeddraModal = true;
            //this.$emit("openmeddra", meddra);
        },
        truncateText(text, length) {
            if (!text) return '';
            return text.length > length ? text.slice(0, length) + '...' : text;
        },
        toggleShow(meddra, field) {
            const key = `${meddra._id}_${field}`;
            this.showFull[key] = !this.showFull[key];
        },
        closeLltModal(payload) {
            this.showMeddraModal = false;
            if (payload.refresh) {
                this.getlist();
            }
        },
        closemodal() {
            this.$router.push(`/meddralistforms`);
        },
        closeFormModal() {
            this.setshowFormModal = false;
            
        }
    },

    computed: {
        filteredFields() {
            return this.meddraenabledfields.filter(field => {
                const categoryMatch = this.selectedCategory === 'all' || field.FieldName.toLowerCase() === this.selectedCategory.toLowerCase();
                const verificationMatch = this.selectedVerification === 'all' ||
                    (this.selectedVerification === 'verified' ? field.Verified : !field.Verified);
                const searchMatch = !this.searchTerm ||
                    Object.values(field).some(val => String(val).toLowerCase().includes(this.searchTerm.toLowerCase()));
                return categoryMatch && verificationMatch && searchMatch;
            });
        },
        categories() {
            return ['all', ...new Set(this.meddraenabledfields.map(f => f.FieldName))];
        }
    }

    // computed: {
    // filteredTerms() {
    //     if (!this.lists || !this.lists.length) return [];

    //     const selected = this.selectedCategory.toLowerCase();

    //     if (selected === 'all') return this.lists;

    //     return this.lists.filter(term => {
    //     const cat = term.category?.toLowerCase() || '';

    //     if (selected === 'gi') {
    //         return cat.includes('gastro');
    //     }
    //     if (selected === 'neuro') {
    //         return cat.includes('nervous');
    //     }

    //     return false;
    //     });
    //     }
    // }
}